import Timer from './timer';

const deposit_voucher_text = voucher => {
    let string = 'Make a deposit';
    if(voucher.minimal_deposit_amount > 0) string += ` <b>from $${voucher.minimal_deposit_amount}</b>`;
    if(voucher.method_prediction !== 'all') {
        if(voucher.method_prediction === 'chime_only') string += ` via <b>Chime</b>`;
        if(voucher.method_prediction === 'cashapp_only') string += ` via <b>CashApp</b>`;
        if(voucher.method_prediction === 'cashapp_chime') string += ` via <b>CashApp</b> or <b>Chime</b>`;
        if(voucher.method_prediction === 'crypto') string += ` via <b>Crypto</b>`;
    }

    string += ` and get <b>+${voucher.bonus}%</b> bonus`;

    return string;
}

const random_boost = details => {
    let string = `Limited Boost: <b>+${details.bonus}%</b> on all deposits, hurry before it’s gone`;
    return string;
}

export default ({deposit_bonus}) => {

    if(!deposit_bonus)
        return <></>;

    /**
     * deposit-voucher
     * random-boost
     * birthday-bonus
     * random-boost
     */

    if(deposit_bonus.type === 'voucher')
        return (
            <div className="wallet-deposit-bonus deposit-voucher">
                <div className="content">
                    <div className="left">
                        <div className="title">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 5.79688C5.4168 5.79688 4.12891 7.08477 4.12891 8.66797C4.12891 10.2512 5.4168 11.5391 7 11.5391C8.5832 11.5391 9.87109 10.2512 9.87109 8.66797C9.87109 7.08477 8.5832 5.79688 7 5.79688ZM8.64062 9.07812H7C6.77359 9.07812 6.58984 8.89438 6.58984 8.66797V7.02734C6.58984 6.80094 6.77359 6.61719 7 6.61719C7.22641 6.61719 7.41016 6.80094 7.41016 7.02734V8.25781H8.64062C8.86703 8.25781 9.05078 8.44156 9.05078 8.66797C9.05078 8.89438 8.86703 9.07812 8.64062 9.07812Z" fill="#FF4356"/>
                                <path d="M8.23047 0.410156C8.23047 0.18375 8.04672 0 7.82031 0C6.87039 0 6.4977 1.24906 6.2002 2.15523C5.99211 2.78879 5.67766 3.74609 5.35938 3.74609C5.11109 3.74609 4.95059 3.01711 4.94922 2.51562C4.94922 2.13883 4.48164 1.96191 4.23199 2.24383C2.93508 3.70891 1.66797 6.2702 1.66797 8.66797C1.66797 11.5842 4.03895 14 7 14C9.94 14 12.332 11.608 12.332 8.66797C12.332 5.23852 8.23047 2.64824 8.23047 0.410156ZM7 12.3594C4.96453 12.3594 3.30859 10.7034 3.30859 8.66797C3.30859 6.6325 4.96453 4.97656 7 4.97656C9.03547 4.97656 10.6914 6.6325 10.6914 8.66797C10.6914 10.7034 9.03547 12.3594 7 12.3594Z" fill="#FF4356"/>
                            </svg>
                            Voucher Bonus <span>+{deposit_bonus.details.bonus}%</span>
                        </div>
                        <div className="description" dangerouslySetInnerHTML={{__html: deposit_voucher_text(deposit_bonus.details)}}></div>
                    </div>
                    <div className="right">
                        <Timer timestamp={deposit_bonus.details.expire_at} />
                    </div>
                </div>
                <div className="background">
                    <div className="bundler"></div>
                    <div className="ellipse"></div>
                </div>
            </div> 
        ) 

    if(deposit_bonus.type === "boost") {
        if(deposit_bonus.details.boost_type === "random")
            return (
                <div className="wallet-deposit-bonus random-boost">
                    <div className="content">
                        <div className="left">
                            <div className="title">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 5.79688C5.4168 5.79688 4.12891 7.08477 4.12891 8.66797C4.12891 10.2512 5.4168 11.5391 7 11.5391C8.5832 11.5391 9.87109 10.2512 9.87109 8.66797C9.87109 7.08477 8.5832 5.79688 7 5.79688ZM8.64062 9.07812H7C6.77359 9.07812 6.58984 8.89438 6.58984 8.66797V7.02734C6.58984 6.80094 6.77359 6.61719 7 6.61719C7.22641 6.61719 7.41016 6.80094 7.41016 7.02734V8.25781H8.64062C8.86703 8.25781 9.05078 8.44156 9.05078 8.66797C9.05078 8.89438 8.86703 9.07812 8.64062 9.07812Z" fill="#FF4356"/>
                                    <path d="M8.23047 0.410156C8.23047 0.18375 8.04672 0 7.82031 0C6.87039 0 6.4977 1.24906 6.2002 2.15523C5.99211 2.78879 5.67766 3.74609 5.35938 3.74609C5.11109 3.74609 4.95059 3.01711 4.94922 2.51562C4.94922 2.13883 4.48164 1.96191 4.23199 2.24383C2.93508 3.70891 1.66797 6.2702 1.66797 8.66797C1.66797 11.5842 4.03895 14 7 14C9.94 14 12.332 11.608 12.332 8.66797C12.332 5.23852 8.23047 2.64824 8.23047 0.410156ZM7 12.3594C4.96453 12.3594 3.30859 10.7034 3.30859 8.66797C3.30859 6.6325 4.96453 4.97656 7 4.97656C9.03547 4.97656 10.6914 6.6325 10.6914 8.66797C10.6914 10.7034 9.03547 12.3594 7 12.3594Z" fill="#FF4356"/>
                                </svg>
                                Deposit Boost <span>+{deposit_bonus.details.bonus}%</span>
                            </div>
                            <div className="description" dangerouslySetInnerHTML={{__html: random_boost(deposit_bonus.details)}}></div>
                        </div>
                        <div className="right">
                            <Timer timestamp={deposit_bonus.details.expire_at} />
                        </div>
                    </div>
                    <div className="background">
                        <div className="bundler"></div>
                        <div className="ellipse"></div>
                    </div>
                </div> 
            )
    }

    return <></>;
}